import React from 'react';

import AppendToBody from 'Component/AppendToBody';

export interface Props {
  titulo?: string;
  children: React.ReactElement | React.ReactElement[] | string;
  exibir: boolean;
  aoFechar: (estado: boolean) => void;
  telaCheiaMobile?: boolean;
  lg?: boolean;
}

const Modal = ({
  titulo,
  children,
  exibir,
  aoFechar,
  telaCheiaMobile = false,
  lg = false,
}: Props): JSX.Element => {
  return (
    <AppendToBody>
      <>
        {exibir && (
          <React.Fragment>
            <div className="modal show animate__animated animate__fadeIn animate__faster d-block">
              <div
                className={[
                  'modal-dialog modal-dialog-centered',
                  telaCheiaMobile && 'modal-fullscreen-sm-down',
                  lg && 'modal-lg',
                ].class()}
              >
                <div className="modal-content border-0">
                  {titulo && (
                    <div className="modal-header">
                      <h5 className="modal-title">{titulo}</h5>
                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => aoFechar(false)}
                      />
                    </div>
                  )}
                  <div className="modal-body">{children}</div>
                </div>
              </div>
            </div>
            <div
              className="modal-backdrop show animate__animated animate__fadeIn animate__faster"
              onClick={() => aoFechar(false)}
            ></div>
          </React.Fragment>
        )}
      </>
    </AppendToBody>
  );
};

export default Modal;
